<template>
	<div class="vx-row">
		<div class="vx-col w-full sm:w-1/1 md:w-1/1 mb-4" v-for="(v, index) in local_properties" :key="index">
			<label
				class="vs-input--label"
				v-if="v.type.findWords('number', 'text', 'email', 'url', 'select', 'date', 'dropdown', 'hour')"
				>{{ v.label.toLowerCase() | title | capitalize }}
				<label class="font-bold text-danger">{{ v.required ? "*" : "" }}</label>
			</label>

			<div v-if="v.type.findWords('text', 'email')">
				<vs-input
					v-show="!validateHexColor(dynamicObject[v.name])"
					:type="v.type"
					class="w-full"
					v-model="dynamicObject[v.name]"
					v-validate="v.type === 'text' ? 'required' : v.type === 'email' ? 'required|email' : 'required'"
					:name="v.name"
					:ref="v.name"
				/>

				<div v-if="typeConfigName === 'VISUAL_CONFIG' && validateHexColor(dynamicObject[v.name])">
					<input
						class="w-10 cursor-pointer h-10 rounded-lg m-2"
						v-model="dynamicObject[v.name]"
						type="color"
					/>
				</div>
			</div>

			<vs-input
				v-if="v.type.findWords('number')"
				type="number"
				class="w-full"
				v-model.number="dynamicObject[v.name]"
				v-validate="v.required ? 'required|numeric' : ''"
				:name="v.name"
				:ref="v.name"
			/>

			<div v-if="v.type.findWords('url')">
				<vx-input-group>
					<vs-input
						v-show="typeConfigName !== 'VISUAL_CONFIG'"
						:type="v.type"
						v-model="dynamicObject[v.name]"
						v-validate="'url:require_protocol|required'"
						:name="v.name"
						:ref="v.name"
					/>

					<template slot="append">
						<div class="append-text btn-addon" v-show="typeConfigName !== 'VISUAL_CONFIG'">
							<vs-button
								:disabled="errors.has(v.name) || !v.name"
								color="primary"
								@click="openUrl(dynamicObject[v.name])"
								>{{ $t("Go") }}
							</vs-button>
						</div>
					</template>
				</vx-input-group>

				<vx-card no-shadow card-border v-if="typeConfigName === 'VISUAL_CONFIG'">
					<div class="flex flex-wrap items-center mt-4">
						<img
							:src="dynamicObject[v.name] ? dynamicObject[v.name] : logo"
							class="mr-8 mb-base img-avatar--cover cursor-pointer hover:background-primary"
							alt=""
							@click="openInputFile(`file-${v.name}`)"
						/>
						<input
							:id="`file-${v.name}`"
							type="file"
							class="hidden"
							@change="onFileChange($event, v.name)"
							accept="image/*"
						/>
						<div class="flex flex-col">
							<div class="flex flex-wrap items-center justify-start">
								<vs-button
									icon-pack="feather"
									icon="icon-image"
									class="mr-4 sm:mb-0 mb-2"
									type="flat"
									color="dark"
									@click="openInputFile(`file-${v.name}`)"
									>{{ $t("Setting.ChooseImage") }}</vs-button
								>

								<vs-button
									v-if="update"
									icon-pack="feather"
									icon="icon-trash-2"
									type="flat"
									radius
									color="danger"
									@click="openConfirm"
								></vs-button>
							</div>
							<div>
								<p class="text-sm mt-2">{{ $t("Setting.AllowedLogo") }}</p>
							</div>
						</div>
					</div>
				</vx-card>
			</div>

			<datepicker
				v-if="v.type.findWords('date')"
				:name="v.name"
				:value="datePikerValue(v.name)"
				@input="datepickerChange($event, v)"
				class="w-full"
			></datepicker>

			<flat-pickr
				v-if="v.type.findWords('hour')"
				:name="v.name"
				:value="datePikerValue(v.name)"
				class="w-full"
				:config="configdateTimePicker"
				v-model="dynamicObject[v.name]"
				placeholder="Choose time"
			/>

			<v-select
				v-if="v.type.findWords('select')"
				v-model="dynamicObject[v.name]"
				:clearable="false"
				@change="errors.clean()"
				:options="v.options"
				:dir="$vs.rtl ? 'rtl' : 'ltr'"
			>
				<template v-slot:no-options="{search, searching}">
					<template v-if="searching">
						{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
					</template>
					<template v-else>
						{{ $t("NoResultsFound") }}
					</template>
				</template>
			</v-select>
			<vx-card no-shadow card-border v-if="v.type.findWords('radio')">
				<label class="vs-input--label">{{ v.label | capitalize }}</label>
				<label class="font-bold text-danger">{{ v.required ? "*" : "" }}</label>
				<ul class="mt-base">
					<li v-for="(option, index) in v.options" :key="index">
						<input
							type="radio"
							:id="`radio-${v.name}`"
							:name="`radio-${v.name}`"
							:value="option"
							v-model="dynamicObject[v.name]"
							class="mr-2"
						/>
						<label :for="`radio-${v.name}`">{{ option }}</label>

						<vs-divider class="mt-1 mb-1"></vs-divider>
					</li>
				</ul>
			</vx-card>

			<vx-card no-shadow card-border v-if="v.type.findWords('check')">
				<label class="vs-input--label">{{ v.label | capitalize }}</label>
				<label class="font-bold text-danger">{{ v.required ? "*" : "" }}</label>
				<ul class="mt-base">
					<li v-for="(option, index) in v.options" :key="index">
						<vs-checkbox v-model="dynamicObject[v.name]" :vs-value="option">{{
							option | title
						}}</vs-checkbox>
						<vs-divider class="mt-1 mb-1"></vs-divider>
					</li>
				</ul>
			</vx-card>

			<vx-card no-shadow card-border v-if="v.type.findWords('check_obj')">
				<label class="vs-input--label">{{ v.label | capitalize }}</label>
				<label class="font-bold text-danger">{{ v.required ? "*" : "" }}</label>
				<ul class="mt-base">
					<li v-for="(option, index) in v.options_obj" :key="index">
						<vs-checkbox v-model="dynamicObject[v.name]" :vs-value="option.value">{{
							option.label | title
						}}</vs-checkbox>
						<vs-divider class="mt-1 mb-1"></vs-divider>
					</li>
				</ul>
			</vx-card>

			<vx-card no-shadow card-border v-if="v.type.findWords('anyOf')">
				<label class="vs-input--label">{{ v.label | capitalize }}</label>
				<label class="font-bold text-danger">{{ v.required ? "*" : "" }}</label>

				<p class="vs-input--label mt-4 mb-2">{{ $t("DesignConfig.AllowValues") }}</p>
				<ul class="flex">
					<li v-for="(field, index) in v.options_composed" :key="index">
						<input
							type="radio"
							v-model="v.composed"
							:id="`radio-${v.name}`"
							:name="`radio-${v.name}`"
							:value="field.type"
						/>
						<label :for="`radio-${v.name}`" class="text-sm ml-2 mr-base">{{
							composedFieldTypes(field.type)
						}}</label>
					</li>
				</ul>

				<ul class="mt-base">
					<li v-for="(option, index) in v.options_composed" :key="index">
						<div v-if="option.type === 'boolean' && v.composed === 'boolean'">
							<ul class="mb-2 flex" v-if="composedBooleanIncludesNull(option.values)">
								<li v-for="(val, i) in option.values" :key="i">
									<vs-radio class="ml-2" v-model="dynamicObject[v.name]" :vs-value="val">{{
										val === null ? "Null" : val === false ? "False" : val | title
									}}</vs-radio>
								</li>
							</ul>

							<vs-switch v-else color="success" v-model="dynamicObject[v.name]" />
						</div>

						<vs-input
							v-if="option.type === 'text' && v.composed === 'text'"
							type="text"
							v-model.trim="dynamicObject[v.name]"
							class="w-full mt-2"
						/>

						<vs-input
							v-if="option.type === 'number' && v.composed === 'number'"
							type="number"
							v-model.number="dynamicObject[v.name]"
							class="w-full mt-2"
						/>
					</li>
				</ul>
			</vx-card>

			<div v-if="v.type.findWords('boolean')">
				<vx-input-group class="p-2 mb-2 border rounded border-solid d-theme-border-grey-light border-rounded">
					<template slot="append">
						<vs-switch color="success" v-model="dynamicObject[v.name]" />
					</template>
					<div>
						<span class="text-sm" v-if="typeConfigName === 'MODULS'">{{
							$t(`Modules.${v.name.toUpperCase()}`).toLowerCase() | title | capitalize
						}}</span>
						<span class="text-sm" v-else>{{ v.label.toLowerCase() | title | capitalize }}</span>
					</div>
				</vx-input-group>
			</div>

			<div>
				<span v-if="v.type.findWords('url')" class="text-danger text-sm" v-show="errors.has(v.name)">{{
					errors.first(v.name)
				}}</span>
				<span
					v-if="v.type.findWords('number', 'text', 'email', 'date')"
					class="text-danger text-sm"
					v-show="errors.has(v.name) || v.error"
					>{{ $t("ErrorVariable.Textvariable1") || v.error_message }}</span
				>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import DateUtils from "@/helpers/DateUtils.js";

import moduleCommon from "@/store/common/moduleCommon.js";
import moduleCompany from "@/store/company/moduleCompany.js";

import {
	removeFileFromFirebase,
	uploadCompanyLogo,
	downloadFileFromFirebase,
	listAllFilesFromFirebaseFolder,
} from "@/helpers/firebaseDB.js";

export default {
	components: {
		vSelect,
		Datepicker,
		flatPickr,
	},
	props: {
		json_properties: {
			type: Array,
			default: () => [],
			required: true,
		},
		config_json: {
			type: Object,
			required: true,
		},
		getDataTrigger: {
			type: Number,
		},
		typeConfigName: {
			type: String,
			default: "",
		},
		companyId: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			local_properties: [],
			dynamicObject: {},
			update: false,
			langHe: es,
			langEn: en,
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
			},

			customPrimaryColor: "#3DC9B3",
			customNavbarColor: "#3DC9B3",
			logo: require("@/assets/images/logo/companies.jpg"),
			dataFile: null,
			fileName: "",
			firebaseResponse: {
				downloadURL: "",
				bucketPath: "",
			},
		};
	},

	computed: {
		datePikerValue() {
			return function (params) {
				if (this.update && this.dynamicObject[params]) {
					return new Date(`${this.dynamicObject[params]} 00:00:00`);
				} else {
					return new Date();
				}
			};
		},

		composedFieldTypes() {
			return function (type) {
				const opts = {
					text: this.$t("DesignConfig.Text"),
					number: this.$t("DesignConfig.Number"),
					boolean: this.$t("DesignConfig.Switch"),
				};
				return opts[type];
			};
		},
		composedBooleanIncludesNull() {
			return function (params = []) {
				return Array.isArray(params) && params.includes(null);
			};
		},

		validateHexColor() {
			return function (color) {
				const regex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
				return regex.test(color);
			};
		},
		validateURL() {
			return function (url) {
				let regex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i;
				return regex.test(url);
			};
		},
		company_logo: {
			get() {
				return this.logo;
			},
			set(val) {
				this.logo = val;
			},
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		datepickerChange($event, v) {
			this.dynamicObject[v.name] = DateUtils.toDefaultDateTime($event, "YYYY-MM-DD");
		},
		openUrl(object) {
			window.open(object);
		},
		parseObjectProperty(object) {
			const parsedObject = {};
			for (let property in object) {
				if (typeof object[property] === "boolean") {
					parsedObject[property] = object[property];
				} else if (!isNaN(object[property])) {
					parsedObject[property] = parseInt(object[property]);
				} else {
					parsedObject[property] = object[property];
				}
			}
			return parsedObject;
		},

		openInputFile(id) {
			document.getElementById(id).click();
		},

		onFileChange(e, id) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.dataFile = files[0];
			this.fileName = this.dataFile.name;
			this.dynamicObject[id] = URL.createObjectURL(files[0]);
		},
		update_avatar() {
			const fileBytes = this.dataFile.size;
			if (fileBytes / 1048576 > 1) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Setting.ImageNotAllowed"),
					text: this.$t("Setting.AllowedLogo"),
					time: 5000,
				});
				return;
			}
			return new Promise((resolve, reject) => {
				(async () => {
					try {
						const listFiles = await listAllFilesFromFirebaseFolder(`serviroutes/${this.companyId}/logo`);
						if (listFiles.length > 0) {
							await removeFileFromFirebase(listFiles[0].fullPath);
						}
						const res = await uploadCompanyLogo.call(
							this,
							this.dataFile,
							`serviroutes/${this.companyId}/logo/`
						);
						Object.assign(this.firebaseResponse, res);
						this.dynamicObject.url_logo = this.firebaseResponse.downloadURL;
						this.$vs.notify({
							color: "success",
							title: this.$t("Setting.VisualSetting"),
							text: this.$t("Setting.ImagenUploaded"),
							time: 5000,
						});
						resolve(res);
					} catch (error) {
						this.handleUploadError(error);
						reject(error);
					}
				})();
			});
		},
		getCompanyLogo(url) {
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.logo = res;
				})
				.catch((error) => {});
		},
		openConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Crud.Delete"),
				text: this.$t("Setting.DeleteImage"),
				accept: this.removeLogo,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		async removeLogo() {
			const listFiles = await listAllFilesFromFirebaseFolder(`serviroutes/${this.companyId}/logo`);
			if (listFiles.length > 0) {
				await removeFileFromFirebase(listFiles[0].fullPath);
			}

			this.dataFile = null;
			this.dynamicObject.url_logo = "";
		},
		handleUploadError(error) {
			switch (error.code) {
				case "storage/unauthorized":
					// User doesn't have permission to access the object
					this.errorUploadNotify("User doesn't have permission to access the object");
					break;
				case "storage/canceled":
					// User canceled the upload
					this.errorUploadNotify("User canceled the upload");
					break;
				case "storage/unknown":
					// Unknown error occurred, inspect error.serverResponse
					// "Ocurrió un error inesperado durante la carga del archivo"
					this.errorUploadNotify("Unknown error occurred, inspect error.serverResponse");
					break;
			}
		},
		errorUploadNotify(message) {
			this.$vs.notify({
				color: "danger",
				title: "Upload Error",
				text: message,
			});
		},
		async handleSave() {
			if (this.update) {
				if (this.typeConfigName === "VISUAL_CONFIG" && this.dataFile) {
					try {
						await this.update_avatar();
						return this.$emit("updateEmit", this.parseObjectProperty(this.dynamicObject));
					} catch (error) {}
				} else {
					this.$emit("updateEmit", this.parseObjectProperty(this.dynamicObject));
				}
			} else {
				if (this.typeConfigName === "VISUAL_CONFIG" && this.dataFile) {
					return this.update_avatar().then((response) => {
						this.$emit("saveEmit", this.parseObjectProperty(this.dynamicObject));
					});
				}
				this.$emit("saveEmit", this.parseObjectProperty(this.dynamicObject));
			}
		},
		extendStringPrototype() {
			String.prototype.findWords = function (...args) {
				return args.some((str) => this === str);
			};
		},
		initializeLocalProperties() {
			this.local_properties = this.json_properties.map((field) =>
				field.type === "anyOf" ? {...field, composed: ""} : field
			);
		},
		initializeDynamicObject() {
			const reduceFormat = (accumulator, currentValue) => {
				let value;
				if (currentValue.type === "check" || currentValue.type === "check_obj") {
					value = [];
				} else if (currentValue.type === "boolean") {
					value = false;
				} else {
					value = "";
				}
				return {
					...accumulator,
					[currentValue.name]: value,
				};
			};
			this.dynamicObject = this.json_properties.reduce(reduceFormat, {});
		},
		handleEditionMode() {
			if (Object.keys(this.config_json).length > 0) {
				this.update = true;
				this.setComposedValues();
				Object.assign(this.dynamicObject, this.config_json);
			} else {
				this.setInitialDynamicObjectValues();
			}
		},
		setComposedValues() {
			const setComposedTypeValue = (val) => {
				if (typeof val === "boolean") return "boolean";
				if (typeof val === "number") return "number";
				if (typeof val === "string") return "text";
				return "";
			};
			const hasAnyOf = this.json_properties.some((field) => field.type === "anyOf");
			if (hasAnyOf) {
				this.local_properties = this.json_properties.map((field) => {
					return field.type === "anyOf"
						? {...field, composed: setComposedTypeValue(this.config_json[field.name])}
						: field;
				});
			}
		},
		setInitialDynamicObjectValues() {
			if (this.typeConfigName === "VISUAL_CONFIG") {
				this.dynamicObject.primary_color = this.customPrimaryColor;
				this.dynamicObject.navbar_color = this.customNavbarColor;
				this.dynamicObject.url_logo = this.logo;
			}
		},
	},
	watch: {
		getDataTrigger() {
			this.handleSave();
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		this.extendStringPrototype();
		this.initializeLocalProperties();
		this.initializeDynamicObject();
		this.handleEditionMode();
	},
};
</script>

<style lang="scss" scoped>
.img-avatar--cover {
	width: 80px !important;
	height: 80px !important;
	object-fit: cover;
}
</style>
